import {
  LOAD_PRODUCTS,
  SET_LISTVIEW,
  SET_GRIDVIEW,
  UPDATE_SORT,
  SORT_PRODUCTS,
  UPDATE_FILTERS,
  FILTER_PRODUCTS,
  CLEAR_FILTERS,
  OPEN_FILTER_MODAL,
  CLOSE_FILTER_MODAL
} from '../actions'

const filter_reducer = (state, action) => {

  if (action.type === LOAD_PRODUCTS) {
    let maxPrice = action.payload.map((item) => item.price)
    maxPrice = Math.max(...maxPrice)

    return { ...state, all_products: [...action.payload], filtered_products: [...action.payload], filters: { ...state.filters, max_price: maxPrice, price: maxPrice } }
  }
  if (action.type === SET_GRIDVIEW) {
    return { ...state, grid_view: true }
  }
  if (action.type === SET_LISTVIEW) {
    return { ...state, grid_view: false }
  }
  if (action.type === UPDATE_SORT) {
    return { ...state, sort: action.payload }
  }
  if (action.type === SORT_PRODUCTS) {
    const { sort, filtered_products } = state
    let tmpProducts = [...filtered_products]
    if (sort === 'price-lowest') {
      tmpProducts = tmpProducts.sort((a, b) => a.price - b.price)
    }
    if (sort === 'price-highest') {
      tmpProducts = tmpProducts.sort((a, b) => b.price - a.price)
    }
    if (sort === 'name-a') {
      tmpProducts = tmpProducts.sort((a, b) => {
        return a.name.localeCompare(b.name)
      })
    }
    if (sort === 'name-z') {
      tmpProducts = tmpProducts.sort((a, b) => {
        return b.name.localeCompare(a.name)
      })
    }
    return { ...state, filtered_products: tmpProducts }
  }
  if (action.type === UPDATE_FILTERS) {
    const { name, value } = action.payload
    return { ...state, filters: { ...state.filters, [name]: value } }
  }
  if (action.type === FILTER_PRODUCTS) {
    const { all_products } = state

    const { text, category, company, color, price, shipping } = state.filters


    let tmpProducts = [...all_products]

    if (text) {
      tmpProducts = tmpProducts.filter((product) => {
        return product.name.toLowerCase().includes(text)
      })
    }
    if (category !== 'all') {
      tmpProducts = tmpProducts.filter((product) => {
        return product.category === category
      })
    }
    if (company !== 'all') {
      tmpProducts = tmpProducts.filter((product) => {
        return product.company === company
      })
    }
    if (color !== 'all') {
      tmpProducts = tmpProducts.filter((product) => {
        return product.colors.find((col) => col === color)
      })
    }
    //price
    tmpProducts = tmpProducts.filter((product) => product.price <= price)

    if (shipping) {
      tmpProducts = tmpProducts.filter((product) => {
        return product.shipping === true
      })
    }

    return { ...state, filtered_products: tmpProducts }
  }
  if (action.type === OPEN_FILTER_MODAL) {
    return { ...state, isFilterModalOpen: true }
  }
  if (action.type === CLOSE_FILTER_MODAL) {
    return { ...state, isFilterModalOpen: false }
  }
  if (action.type === CLEAR_FILTERS) {
    return {
      ...state, filters: {
        ...state.filters,
        text: '',
        company: 'all',
        category: 'all',
        color: 'all',
        price: state.filters.max_price,
        shipping: false,

      }
    }
  }

  throw new Error(`No Matching "${action.type}" - action type`)
}

export default filter_reducer
